import { createApiClient } from "@turbozaim/auth-service-client";
import { env } from "~/env";
import { createAxiosInstance } from "./createAxiosInstance";

const axiosInstance = createAxiosInstance({
  withCredentials: true,
});
const apiUrl = env.VITE_USE_PROXY ? "/auth" : env.VITE_AUTH_API_URL;
export const authApi = createApiClient(apiUrl, {
  axiosInstance,
});
